import React from "react";
import { Link } from "react-router-dom";
import "../massageChatAuthor/MessageChatAuthor.css";
import GiftModal from "../modal/gift/GiftModal";

const MessageChatAuthor = () => {
  document.addEventListener("input", function (event) {
    if (event.target.dataset.autoresize === "true") {
      const textarea = event.target;
      textarea.style.height = "auto"; // Reset height to auto to recalculate
      textarea.style.height = textarea.scrollHeight + "px"; // Set height to match content
    }
  });

  return (
    <div className="cust-massage-box">
      <div className="chat-sliders d-lg-none">
        <button
          className="btn btn-primary"
          data-bs-toggle="offcanvas"
          href="#offcanvasExample"
          role="button"
          aria-controls="offcanvasExample"
        >
          <svg
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-sliders"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1z"
            />
          </svg>{" "}
          Chats
        </button>
      </div>
      <div className="d-flex">
        <div
          className="chat-sidebar offcanvas offcanvas-start"
          tabindex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
        >
          <div className="chat-sidebar-inner">
            <div className="chat-sidebar-header">
              <div className="search-section-following">
                <div className="search-box">
                  <div className="search-container">
                    <form action="">
                      <div className="form-search-box">
                        <button type="submit">
                          <svg
                            width="23"
                            height="22"
                            viewBox="0 0 23 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.3418 19.25C16.1512 19.25 20.0501 15.3512 20.0501 10.5417C20.0501 5.7322 16.1512 1.83334 11.3418 1.83334C6.53228 1.83334 2.63342 5.7322 2.63342 10.5417C2.63342 15.3512 6.53228 19.25 11.3418 19.25Z"
                              stroke="#787486"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M20.9668 20.1667L19.1334 18.3333"
                              stroke="#787486"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                        <input type="search" placeholder="Search.." name="" />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <ul className="nav" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="tab1-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#tab1"
                    type="button"
                    role="tab"
                    aria-controls="tab1"
                    aria-selected="true"
                  >
                    Inbox
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="tab2-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#tab2"
                    type="button"
                    role="tab"
                    aria-controls="tab2"
                    aria-selected="false"
                  >
                    Requests
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="tab3-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#tab3"
                    type="button"
                    role="tab"
                    aria-controls="tab3"
                    aria-selected="false"
                  >
                    Archived
                  </button>
                </li>
              </ul>
            </div>
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="tab1"
                role="tabpanel"
                aria-labelledby="tab1-tab"
              >
                <div className="chat-sidebar-body">
                  <ul className="flex-column nav-chat-menu">
                    <li
                      className="d-flex align-items-center"
                      data-bs-dismiss="offcanvas"
                    >
                      <Link className="w-100">
                        <div className="d-flex">
                          <div className="flex-shrink-0 avatar me-2">
                            <div className="img-box"></div>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="user-chat-name">chloelovesyou</div>
                            <span className="chat-status text-start d-block">
                              Hey
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li
                      className="d-flex align-items-center"
                      data-bs-dismiss="offcanvas"
                    >
                      <Link className="w-100">
                        <div className="d-flex">
                          <div className="flex-shrink-0 avatar me-2">
                            <div className="img-box"></div>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="user-chat-name">chloelovesyou</div>
                            <span className="chat-status text-start d-block">
                              Sounds good x{" "}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li
                      className="d-flex align-items-center"
                      data-bs-dismiss="offcanvas"
                    >
                      <Link className="w-100">
                        <div className="d-flex">
                          {" "}
                          <div className="flex-shrink-0 avatar me-2">
                            <div className="img-box"></div>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="user-chat-name">chloelovesyou</div>
                            <span className="chat-status text-start d-block">
                              Sounds good x
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="tab2"
                role="tabpanel"
                aria-labelledby="tab2-tab"
              >
                <div className="chat-sidebar-body">
                  <ul className="flex-column nav-chat-menu">
                    <li
                      className="d-flex align-items-center"
                      data-bs-dismiss="offcanvas"
                    >
                      <Link className="w-100">
                        <div className="d-flex">
                          <div className="flex-shrink-0 avatar me-2">
                            <div className="img-box"></div>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="user-chat-name">chloelovesyou</div>
                            <span className="chat-status text-start d-block">
                              Hey
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li
                      className="d-flex align-items-center"
                      data-bs-dismiss="offcanvas"
                    >
                      <Link className="w-100">
                        <div className="d-flex">
                          <div className="flex-shrink-0 avatar me-2">
                            <div className="img-box"></div>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="user-chat-name">chloelovesyou</div>
                            <span className="chat-status text-start d-block">
                              Sounds good x{" "}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li
                      className="d-flex align-items-center"
                      data-bs-dismiss="offcanvas"
                    >
                      <Link className="w-100">
                        <div className="d-flex">
                          {" "}
                          <div className="flex-shrink-0 avatar me-2">
                            <div className="img-box"></div>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="user-chat-name">chloelovesyou</div>
                            <span className="chat-status text-start d-block">
                              Sounds good x
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="tab3"
                role="tabpanel"
                aria-labelledby="tab3-tab"
              >
                <div className="chat-sidebar-body">
                  <ul className="flex-column nav-chat-menu">
                    <li
                      className="d-flex align-items-center"
                      data-bs-dismiss="offcanvas"
                    >
                      <Link className="w-100">
                        <div className="d-flex">
                          <div className="flex-shrink-0 avatar me-2">
                            <div className="img-box"></div>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="user-chat-name">chloelovesyou</div>
                            <span className="chat-status text-start d-block">
                              Hey
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li
                      className="d-flex align-items-center"
                      data-bs-dismiss="offcanvas"
                    >
                      <Link className="w-100">
                        <div className="d-flex">
                          <div className="flex-shrink-0 avatar me-2">
                            <div className="img-box"></div>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="user-chat-name">chloelovesyou</div>
                            <span className="chat-status text-start d-block">
                              Sounds good x{" "}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li
                      className="d-flex align-items-center"
                      data-bs-dismiss="offcanvas"
                    >
                      <Link className="w-100">
                        <div className="d-flex">
                          {" "}
                          <div className="flex-shrink-0 avatar me-2">
                            <div className="img-box"></div>
                          </div>
                          <div className="d-flex flex-column">
                            <div className="user-chat-name">chloelovesyou</div>
                            <span className="chat-status text-start d-block">
                              Sounds good x
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-chat d-flex flex-column flex-grow-1">
          <div className="card-chat-header">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center mb-2 mb-sm-0">
                <div className="flex-shrink-0 avatar me-3">
                  <div className="img-box-head"></div>
                </div>
                <div className="d-block flex-grow-1">
                  <h6 className="mb-0 user-chat-name">John Doe</h6>
                </div>
              </div>
              
              <div className='header-setting d-flex align-items-center ms-auto'>
                        <button className='btn btn-call'>
                          <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9683 21.1854C17.083 21.8206 18.4112 22.0975 19.7298 21.9694C21.0484 21.8412 22.2768 21.316 23.2085 20.4817L24.023 19.7781C24.3801 19.4553 24.5801 19.022 24.5801 18.5708C24.5801 18.1195 24.3801 17.6861 24.023 17.3635L20.5658 14.3411C20.2036 14.0266 19.7161 13.8504 19.2083 13.8504C18.7004 13.8504 18.2129 14.0266 17.8507 14.3411C17.4855 14.6566 16.9949 14.8332 16.4841 14.8332C15.9733 14.8332 15.4828 14.6566 15.1175 14.3411L9.68736 9.54376C9.50621 9.38605 9.36236 9.19809 9.26417 8.99083C9.16599 8.78357 9.11542 8.56112 9.11542 8.33644C9.11542 8.11174 9.16599 7.8893 9.26417 7.68203C9.36236 7.47476 9.50621 7.28681 9.68736 7.1291C10.0433 6.80912 10.2428 6.37841 10.2428 5.92977C10.2428 5.48111 10.0433 5.05042 9.68736 4.73042L6.24828 1.6921C5.88297 1.37662 5.3925 1.19998 4.88173 1.19998C4.37077 1.19998 3.8803 1.37662 3.51499 1.6921L2.71853 2.41171C1.77443 3.23483 1.17985 4.3201 1.03474 5.48499C0.889634 6.6499 1.20307 7.82339 1.92226 8.80817C5.66911 13.6866 10.4366 17.8877 15.9683 21.1854Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </button>
                        <Link rel='stylesheet' to="/videocall" className='btn btn-video-call'>
                          <svg width="29" height="23" viewBox="0 0 29 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.5092 4.08887L20.8258 6.97776V3.51109C20.8258 2.89814 20.6135 2.31031 20.2355 1.87688C19.8576 1.44348 19.345 1.19998 18.8104 1.19998H3.69507C3.16055 1.19998 2.64794 1.44348 2.26998 1.87688C1.89202 2.31031 1.67969 2.89814 1.67969 3.51109V19.6889C1.67969 20.3018 1.89202 20.8897 2.26998 21.3231C2.64794 21.7564 3.16055 22 3.69507 22H18.8104C19.345 22 19.8576 21.7564 20.2355 21.3231C20.6135 20.8897 20.8258 20.3018 20.8258 19.6889V16.2222L26.5092 19.1111C26.6624 19.1788 26.8278 19.2028 26.9909 19.1804C27.1539 19.1582 27.3099 19.0908 27.4449 18.9835C27.58 18.8765 27.6902 18.7332 27.766 18.5661C27.8418 18.399 27.8809 18.2132 27.8797 18.0249V5.17509C27.8809 4.98676 27.8418 4.80095 27.766 4.63385C27.6902 4.46676 27.58 4.32343 27.4449 4.21635C27.3099 4.10926 27.1539 4.04168 26.9909 4.01945C26.8278 3.99724 26.6624 4.02106 26.5092 4.08887Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </Link>
                        <div className="btn-group">
                          <button type="button" className="btn btn-setting-box" data-bs-toggle="modal" data-bs-target="#staticBackdrop10">
                            <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.9587 24.8964V12.607H3.43896V24.8964C3.43896 26.0582 4.39452 27 5.57324 27H23.8244C25.0032 27 25.9587 26.0582 25.9587 24.8964Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.6997 26.9999V12.603" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.7996 9.23954V10.5034C27.7996 11.6652 26.8441 12.6071 25.6653 12.6071H3.73388C2.55516 12.6071 1.59961 11.6652 1.59961 10.5034V9.23954C1.59961 8.07774 2.55516 7.13589 3.73388 7.13589H25.6653C26.8441 7.13589 27.7996 8.07774 27.7996 9.23954Z" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.6997 7.13564C14.6997 5.29495 12.521 1 9.2529 1C3.93619 1 5.87294 7.13564 8.41765 7.13564" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.6997 7.13564C14.6997 5.29495 16.8784 1 20.1465 1C25.4633 1 23.5264 7.13564 20.9818 7.13564" stroke="#FD59D9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                          </button>
                          {/* <ul className="dropdown-menu dropdown-menu-end">
                            <li><button className="dropdown-item" type="button">Action</button></li>
                            <li><button className="dropdown-item" type="button">Another action</button></li>
                            <li><button className="dropdown-item" type="button">Something else here</button></li>
                          </ul> */}
                        </div>

                        <div className='worker-dropdown dropdown'>
                      <Link rel='stylesheet' className='dropdown-toggle btn btn-setting-box ' data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" aria-label="Toggle worker options">
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.45088 14.0049C11.0684 14.0049 14.0009 11.0948 14.0009 7.50488C14.0009 3.91503 11.0684 1.00488 7.45088 1.00488C3.83341 1.00488 0.900879 3.91503 0.900879 7.50488C0.900879 11.0948 3.83341 14.0049 7.45088 14.0049Z" stroke="#ADAAAA" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.42795 7.75488C4.28882 7.75488 4.17603 7.64295 4.17603 7.50488C4.17603 7.36681 4.28882 7.25488 4.42795 7.25488" stroke="#ADAAAA" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4.42798 7.75488C4.56711 7.75488 4.6799 7.64295 4.6799 7.50488C4.6799 7.36681 4.56711 7.25488 4.42798 7.25488" stroke="#ADAAAA" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.45065 7.75488C7.31152 7.75488 7.19873 7.64295 7.19873 7.50488C7.19873 7.36681 7.31152 7.25488 7.45065 7.25488" stroke="#ADAAAA" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7.45068 7.75488C7.58982 7.75488 7.70261 7.64295 7.70261 7.50488C7.70261 7.36681 7.58982 7.25488 7.45068 7.25488" stroke="#ADAAAA" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10.4738 7.75488C10.3347 7.75488 10.2219 7.64295 10.2219 7.50488C10.2219 7.36681 10.3347 7.25488 10.4738 7.25488" stroke="#ADAAAA" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10.4741 7.75488C10.6133 7.75488 10.726 7.64295 10.726 7.50488C10.726 7.36681 10.6133 7.25488 10.4741 7.25488" stroke="#ADAAAA" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                      </Link>
                      <div class="dropdown-menu worker-menu">
                        <div className='worker-menu-box'>
                          <ul className=''>
                              <li>
                                  <Link rel='stylesheet' to='' className='link-text'>Block</Link>
                              </li>
                              <li>
                                  <Link rel='stylesheet' to='' className='link-text'>Report</Link>
                              </li>
                              <li>
                                  <Link rel='stylesheet' to='' className='link-text'>Mute</Link>
                              </li>
                          </ul>
                        </div>
                      </div>
                  </div>

                </div>
              {/* <div className="header-setting d-flex align-items-center ms-auto">
                <button className="btn btn-call">
                  <svg
                    width="26"
                    height="23"
                    viewBox="0 0 26 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.9683 21.1854C17.083 21.8206 18.4112 22.0975 19.7298 21.9694C21.0484 21.8412 22.2768 21.316 23.2085 20.4817L24.023 19.7781C24.3801 19.4553 24.5801 19.022 24.5801 18.5708C24.5801 18.1195 24.3801 17.6861 24.023 17.3635L20.5658 14.3411C20.2036 14.0266 19.7161 13.8504 19.2083 13.8504C18.7004 13.8504 18.2129 14.0266 17.8507 14.3411C17.4855 14.6566 16.9949 14.8332 16.4841 14.8332C15.9733 14.8332 15.4828 14.6566 15.1175 14.3411L9.68736 9.54376C9.50621 9.38605 9.36236 9.19809 9.26417 8.99083C9.16599 8.78357 9.11542 8.56112 9.11542 8.33644C9.11542 8.11174 9.16599 7.8893 9.26417 7.68203C9.36236 7.47476 9.50621 7.28681 9.68736 7.1291C10.0433 6.80912 10.2428 6.37841 10.2428 5.92977C10.2428 5.48111 10.0433 5.05042 9.68736 4.73042L6.24828 1.6921C5.88297 1.37662 5.3925 1.19998 4.88173 1.19998C4.37077 1.19998 3.8803 1.37662 3.51499 1.6921L2.71853 2.41171C1.77443 3.23483 1.17985 4.3201 1.03474 5.48499C0.889634 6.6499 1.20307 7.82339 1.92226 8.80817C5.66911 13.6866 10.4366 17.8877 15.9683 21.1854Z"
                      stroke="#FD59D9"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <Link
                  rel="stylesheet"
                  to="/videocall"
                  className="btn btn-video-call"
                >
                  <svg
                    width="29"
                    height="23"
                    viewBox="0 0 29 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.5092 4.08887L20.8258 6.97776V3.51109C20.8258 2.89814 20.6135 2.31031 20.2355 1.87688C19.8576 1.44348 19.345 1.19998 18.8104 1.19998H3.69507C3.16055 1.19998 2.64794 1.44348 2.26998 1.87688C1.89202 2.31031 1.67969 2.89814 1.67969 3.51109V19.6889C1.67969 20.3018 1.89202 20.8897 2.26998 21.3231C2.64794 21.7564 3.16055 22 3.69507 22H18.8104C19.345 22 19.8576 21.7564 20.2355 21.3231C20.6135 20.8897 20.8258 20.3018 20.8258 19.6889V16.2222L26.5092 19.1111C26.6624 19.1788 26.8278 19.2028 26.9909 19.1804C27.1539 19.1582 27.3099 19.0908 27.4449 18.9835C27.58 18.8765 27.6902 18.7332 27.766 18.5661C27.8418 18.399 27.8809 18.2132 27.8797 18.0249V5.17509C27.8809 4.98676 27.8418 4.80095 27.766 4.63385C27.6902 4.46676 27.58 4.32343 27.4449 4.21635C27.3099 4.10926 27.1539 4.04168 26.9909 4.01945C26.8278 3.99724 26.6624 4.02106 26.5092 4.08887Z"
                      stroke="#FD59D9"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </Link>

                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-setting-box"
                    data-bs-toggle="dropdown"
                    data-bs-display="static"
                    aria-expanded="false"
                  >
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.45088 14.0049C11.0684 14.0049 14.0009 11.0948 14.0009 7.50488C14.0009 3.91503 11.0684 1.00488 7.45088 1.00488C3.83341 1.00488 0.900879 3.91503 0.900879 7.50488C0.900879 11.0948 3.83341 14.0049 7.45088 14.0049Z"
                        stroke="#ADAAAA"
                        stroke-width="0.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.42795 7.75488C4.28882 7.75488 4.17603 7.64295 4.17603 7.50488C4.17603 7.36681 4.28882 7.25488 4.42795 7.25488"
                        stroke="#ADAAAA"
                        stroke-width="0.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.42798 7.75488C4.56711 7.75488 4.6799 7.64295 4.6799 7.50488C4.6799 7.36681 4.56711 7.25488 4.42798 7.25488"
                        stroke="#ADAAAA"
                        stroke-width="0.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.45065 7.75488C7.31152 7.75488 7.19873 7.64295 7.19873 7.50488C7.19873 7.36681 7.31152 7.25488 7.45065 7.25488"
                        stroke="#ADAAAA"
                        stroke-width="0.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.45068 7.75488C7.58982 7.75488 7.70261 7.64295 7.70261 7.50488C7.70261 7.36681 7.58982 7.25488 7.45068 7.25488"
                        stroke="#ADAAAA"
                        stroke-width="0.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10.4738 7.75488C10.3347 7.75488 10.2219 7.64295 10.2219 7.50488C10.2219 7.36681 10.3347 7.25488 10.4738 7.25488"
                        stroke="#ADAAAA"
                        stroke-width="0.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10.4741 7.75488C10.6133 7.75488 10.726 7.64295 10.726 7.50488C10.726 7.36681 10.6133 7.25488 10.4741 7.25488"
                        stroke="#ADAAAA"
                        stroke-width="0.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <button className="dropdown-item" type="button">
                        Action
                      </button>
                    </li>
                    <li>
                      <button className="dropdown-item" type="button">
                        Another action
                      </button>
                    </li>
                    <li>
                      <button className="dropdown-item" type="button">
                        Something else here
                      </button>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
          <div className="card-chat-body">
            <div className="d-flex mb-1">
              <div className="flex-grow-1">
                <div className="w-100">
                  <div className="d-flex align-items-start">
                    <div className="img-author">
                      <div className="img-box"></div>
                    </div>
                    <div className="bg-light">
                      Lorem ipsum dolor sit amet consectetur. Dignissim mauris
                      nulla porta in sed nulla facilisi.😟😧
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end text-end mb-1">
              <div className="w-100">
                <div className="d-flex align-items-end flex-row-reverse">
                  <div className="img-author">
                    <div className="img-box"></div>
                  </div>
                  <div className="bg-primary">
                    Lorem ipsum dolor sit amet consectetur. Dignissim mauris
                    nulla porta in sed nulla facilisi.😭🌈
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex mb-1">
              <div className="flex-grow-1">
                <div className="w-100">
                  <div className="d-flex align-items-start">
                    <div className="img-author">
                      <div className="img-box"></div>
                    </div>
                    <div className="bg-light">
                      Lorem ipsum dolor sit amet consectetur. Dignissim mauris
                      nulla porta in sed nulla facilisi.😟😧
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end text-end mb-1">
              <div className="w-100">
                <div className="d-flex align-items-end flex-row-reverse">
                  <div className="img-author">
                    <div className="img-box"></div>
                  </div>
                  <div className="bg-primary">
                    Lorem ipsum dolor sit amet consectetur. Dignissim mauris
                    nulla porta in sed nulla facilisi.😭🌈
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-chat-footer">
            <div className="d-flex align-items-center">
              <div className="position-relative w-100">
                <textarea
                  className="form-control"
                  data-autoresize="true"
                  placeholder="Message"
                  rows="1"
                ></textarea>

                {/* <div className='box-camera btn-fill-upload'>
                      <input type="file" />
                    </div> */}
                <div className="box-camera">
                  <svg
                    width="21"
                    height="24"
                    viewBox="0 0 21 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.25 11.1538C15.25 12.2759 14.7495 13.352 13.8588 14.1455C12.968 14.9389 11.7598 15.3846 10.5 15.3846C9.24022 15.3846 8.03203 14.9389 7.14124 14.1455C6.25044 13.352 5.75 12.2759 5.75 11.1538V5.23077C5.75 4.1087 6.25044 3.03258 7.14124 2.23916C8.03203 1.44574 9.24022 1 10.5 1C11.7598 1 12.968 1.44574 13.8588 2.23916C14.7495 3.03258 15.25 4.1087 15.25 5.23077V11.1538Z"
                      stroke="#787486"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20 12C20.0024 13.0007 19.783 13.992 19.3544 14.9169C18.9255 15.8419 18.2959 16.6823 17.5013 17.3898C16.7069 18.0974 15.7634 18.6584 14.7249 19.0402C13.6864 19.4221 12.5735 19.6176 11.45 19.6154H9.55001C8.4265 19.6176 7.31358 19.4221 6.27512 19.0402C5.23666 18.6584 4.29312 18.0974 3.49867 17.3898C2.70422 16.6823 2.07455 15.8419 1.64575 14.9169C1.21696 13.992 0.997513 13.0007 1.00002 12"
                      stroke="#787486"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.5 19.6154V23"
                      stroke="#787486"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="box-attachment btn-fill-upload">
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.53846 20H19.4615C20.3112 20 21 19.3457 21 18.5385V2.46154C21 1.65435 20.3112 1 19.4615 1H2.53846C1.68879 1 1 1.65435 1 2.46154V18.5385C1 19.3457 1.68879 20 2.53846 20Z"
                      stroke="#787486"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.92285 20L14.1536 9.94456C14.2918 9.83519 14.466 9.7753 14.6459 9.7753C14.8258 9.7753 15 9.83519 15.1382 9.94456L20.9998 13.9346"
                      stroke="#787486"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.15388 9.03845C8.42839 9.03845 9.46158 8.05693 9.46158 6.84615C9.46158 5.63536 8.42839 4.65384 7.15388 4.65384C5.87938 4.65384 4.84619 5.63536 4.84619 6.84615C4.84619 8.05693 5.87938 9.03845 7.15388 9.03845Z"
                      stroke="#787486"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <input type="file" />
                </div>
              </div>
              {/* <button className='btn btn-primary btn-send-msg'>
                    <img src={Iconplan} alt='' />
                  </button> */}
            </div>
          </div>
        </div>
      </div>
      
      <GiftModal />

    </div>
  );
};

export default MessageChatAuthor;
